module.exports = "<svg width=\"47\" height=\"47\" viewBox=\"0 0 47 47\" xmlns=\"http://www.w3.org/2000/svg\"><title>back-arrow</title><path d=\"M23.5 0C36.479 0 47 10.521 47 23.5S36.479 47 23.5 47 0 36.479 0 23.5 10.521 0 23.5 0zm-4.375 27.791v-3.088h13.874v-3H19.124v-3.089a.208.208 0 0 0-.34-.16l-5.55 4.59c-.1.082-.1.236 0 .32l5.55 4.588c.135.111.34.016.34-.16z\" fill=\"#FFF\" fill-rule=\"evenodd\" opacity=\".503\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/icons/back-arrow.svg
// module id = ./node_modules/raw-loader/index.js!./src/icons/back-arrow.svg
// module chunks = 168707334958949